import './index.scss'
import projects from '../../../data/projects'

const NewsArticleDetail = () => {
  const project = projects.find((p) => p.slug === 'news-article-analysis') || {}

  return (
    <main className="project-detail">
      <div className="site-container">
      <section className="project-detail__hero">
        <h1>{project.title}</h1>
        <h3>{project.role} @ {project.organisation} ({project.timeline})</h3>
        {project.skills && (
          <ul className="project-detail__skills">
            {project.skills.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        )}
      </section>

      <section className="project-detail__content">
        <p>{project.description}</p>
        <div className="project-detail__image_box">
          <img src={project.evidence_image} alt="Screenshot of Application" className="project-detail__evidence_image" />
        </div>
        <h3>Problem Overview</h3>
        <p>{project.problem_overview}</p>

        <h3>Implementation Details</h3>
        <ul className="project-detail__implementation">
          {project.implementation_bullets.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>
        
        <h3>Technical Highlights</h3>
        <table className="project-detail__tech-table">
          <tr>
            <th>Area</th>
            <th>Approach</th>
          </tr>
          {project.technical_details_table.map(([title, text], index) => (
            <tr key={index}>
              <td>{title}</td>
              <td>{text}</td>
            </tr>
          ))}
        </table>

        <h3>System Architecture Diagram</h3>
        <div className="project-detail__image_box">
          <img src={project.architecture_diagram} alt="System Architecture Diagram" className="project-detail__architecture_image" />
        </div>

        <h3>Key Results & Lessons</h3>
        <ul className="project-detail__results">
          {project.results_bullets.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>

        <h3>My Contribution</h3>
        <p>{project.contribution_summary}</p>
        <p><b>Technologies used:</b> {project.tech_bullets.join(', ')}</p>

        <p><b>Report Unavaliable</b></p>
      </section>
      </div>
    </main>
  )
}

export default NewsArticleDetail
